module.exports = __webpack_public_path__ + "static/img/icon_log_off.11c310c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_log_off.png
// module id = 240
// module chunks = 1